// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__KbrvM","title":"Images45_title__25H2I","images":"Images45_images__3OGim"};